import { createSlice } from "@reduxjs/toolkit"
import set from "lodash/set"

import { ApplePayInitParams } from "@payair/apple-pay-sdk/models/ApplePayInitParams"
import { ApplePayButtonParams } from "@payair/apple-pay-sdk/models/ApplePayButtonParams"

import { ApplePayButtonColorEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayButtonColorEnum"
import { ApplePayButtonTypeEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayButtonTypeEnum"
import { ApplePayPaymentRequest } from "@payair/apple-pay-sdk/models/ApplePayPaymentRequest"
import { AppleInputs, LineItem } from "../../models/AppleInputs"
import { ApplePayShippingMethod } from "@payair/apple-pay-sdk/models/ApplePayShippingMethod"

const contact = {
  emailAddress: "test@test.pl",
  familyName: "Testowski",
  givenName: "Test",
  phoneNumber: "+48822222222",
  phoneticFamilyName: "Testowski",
  phoneticGivenName: "Test",
  addressLines: ["Test Street 99"],
  locality: "Test City",
  subLocality: "Test subLocality",
  administrativeArea: "Test administrativeArea",
  subAdministrativeArea: "Test subAdministrativeArea",
  postalCode: "99999",
  country: "Sweden",
  countryCode: "SE"
}

const shippingMethodOne: ApplePayShippingMethod = {
  label: "shippingMethodOne label",
  detail: "shippingMethodOne detail",
  amount: "15.00",
  identifier: "Test delivery company identifier",
  dateComponentsRange: {
    startDateComponents: { years: 99, months: 1, days: 1, hours: 1},
    endDateComponents: { years: 99, months: 1, days: 1, hours: 1}
  }
}

const applePayPaymentRequest: ApplePayPaymentRequest = {
  merchantCapabilities: ["supports3DS"],
  supportedNetworks: ["visa", "mastercard"],

  billingContact: contact,
  requiredBillingContactFields: ["postalAddress"],
  requiredShippingContactFields: ["email", "name", "phone", "postalAddress", "phoneticName"],
  shippingContact: contact,
  shippingMethods: [shippingMethodOne],
  shippingType: "delivery",
  shippingContactEditingMode: "enabled",
  supportedCountries: ["PL", "SE"],
  applicationData: "applicationDataTest"
}

const applePayInitParams: ApplePayInitParams  = {
  currencyCode: "SEK",
  totalAmount: "1.00",
  totalAmountLabel: "Total",
  merchantName: "Payair test merchant",
  merchantId: "test.merchant.ape",
  pspName: "dev",
  transactionId: "Test tool " + Date.now(),
  applePayPaymentRequest: applePayPaymentRequest,
  locale: ""
}

const applePayButtonParams: ApplePayButtonParams = {
  buttonColor: ApplePayButtonColorEnumsObj.BLACK,
  buttonType: ApplePayButtonTypeEnumsObj.PLAIN
}

const lineItem: LineItem = {
  amount: "1.99",
  deferredPaymentDate: "",
  label: "TestProduct",
  paymentTiming: "immediate",
  recurringPaymentEndDate: "",
  recurringPaymentIntervalCount: 1,
  recurringPaymentIntervalUnit: "year",
  recurringPaymentStartDate: "",
  type: "final"
}

const appleInputs: AppleInputs = {
  applicationData: "applicationDataTest",
  billingContact: contact,
  lineItems: [lineItem],
  merchantCapabilities: ["supports3DS"],
  requiredBillingContactFields: ["postalAddress"],
  requiredShippingContactFields: ["email", "name", "phone", "postalAddress", "phoneticName"],
  shippingContact: contact,
  shippingContactEditingMode: "enabled",
  shippingMethods: [shippingMethodOne],
  shippingType: "delivery",
  supportedCountries: ["PL", "SE"],
  supportedNetworks: ["visa", "mastercard"],
  total: {
    amount: "1.99",
    deferredPaymentDate: undefined,
    label: "TestProduct",
    paymentTiming: "immediate",
    recurringPaymentEndDate: undefined,
    recurringPaymentIntervalCount: undefined,
    recurringPaymentIntervalUnit: "year",
    recurringPaymentStartDate: undefined,
    type: "final"
  },
  useShippingMethods: true,
  useBillingAddress: true,
  useShippingAddress: true,
  applePayButton: {
    color: "black",
    type: "pay"
  }
}

const applepayInputData = {
  appleInputs: appleInputs,
  applePayInitParams: applePayInitParams,
  applePayButtonParams: applePayButtonParams
}

export const saveToStorage = (state: any, action: any) => {
  const payload = action.payload
  const name = payload.name
  const value = payload.value

  return set(state, name, value)
}

export const applepayInputDataReducer = createSlice({
  name: 'applepayInputData',
  initialState: applepayInputData,
  reducers: { 
    save: (state, action) => {
      saveToStorage(state, action)
    }
  }
})

const { actions, reducer } = applepayInputDataReducer
export const { save } = actions
export default reducer
